document.addEventListener('DOMContentLoaded', function() {

  function getRelativePosition(element, relativeElement) {
    const elementRect = element.getBoundingClientRect();
    const relativeElementRect = relativeElement.getBoundingClientRect();
    return {
      top: elementRect.top - relativeElementRect.top,
      right: elementRect.right - relativeElementRect.right,
      bottom: elementRect.bottom - relativeElementRect.bottom,
      left: elementRect.left - relativeElementRect.left
    };
  }

  document.querySelectorAll('.js-timeline').forEach(function(timeline) {
    const stickyThreshold = timeline.querySelector('.js-timeline-sticky-threshold');
    let stickyThresholdTop = parseInt(getComputedStyle(stickyThreshold).top);
    let stickyThresholdHeight = stickyThreshold.getBoundingClientRect().height;
    let breakpoint = getComputedStyle(timeline).getPropertyValue('--breakpoint').replace(/"/g, '');

    const firstItem = timeline.querySelector('.js-timeline-item');
    const firstItemDot = firstItem.querySelector('.c-timeline__item-dot');

    const timelineItems = timeline.querySelectorAll('.js-timeline-item');
    const lastItem = timelineItems[timelineItems.length - 1];
    lastItem.style.height = 'auto'
    if (lastItem.getBoundingClientRect().height < stickyThresholdHeight) {
      lastItem.style.height = stickyThresholdHeight + 'px';
    }

    document.addEventListener('scroll', function() {
      const scrollThreshold = breakpoint == 'mobile' ? window.innerHeight/2 : stickyThresholdTop;

      timeline.querySelectorAll('.js-timeline-item').forEach(function(item) {
        const itemRect = item.getBoundingClientRect();

        if (itemRect.top < scrollThreshold) {
          item.classList.add('c-timeline__item--active');
        }
        else {
          item.classList.remove('c-timeline__item--active');
        }
      });

      let diff = 0;
      if (breakpoint == 'mobile') {
        diff = (firstItemDot.getBoundingClientRect().top - window.innerHeight/2) * -1;
      }
      else {
        diff = getRelativePosition(firstItemDot, stickyThreshold).top * -1;
      }
      diff = diff < 0 ? 0 : diff;
      timeline.querySelector('.js-timeline-progress').style.height = diff + 'px';
    });

    window.addEventListener('resize', () => {
      stickyThresholdTop = parseInt(getComputedStyle(stickyThreshold).top);
      stickyThresholdHeight = stickyThreshold.getBoundingClientRect().height;
      breakpoint = getComputedStyle(timeline).getPropertyValue('--breakpoint').replace(/"/g, '');

      lastItem.style.height = 'auto';
      if (lastItem.getBoundingClientRect().height < stickyThresholdHeight) {
        lastItem.style.height = stickyThresholdHeight + 'px';
      }
    });
  });

  document.dispatchEvent(new Event('scroll'));

});
